import React from 'react';

import type { ExtensionManifest } from '@atlaskit/editor-common/extensions/extension-manifest';
import type { ExtensionParams } from '@atlaskit/editor-common/extensions/extension-handler';

import { REDACTION_EXTENSION_TYPE, type RedactionExtensionParams } from '../redaction-constants.ts';

import { TourableRedactionExtensionLoader } from './TourableRedactionExtensionLoader.tsx';

export const createTourableRedactionExtension = ({
	contentId,
	isCommentContext = false,
}: {
	contentId?: string | null;
	isCommentContext?: boolean;
}): ExtensionManifest => {
	return {
		title: 'Redaction',
		type: REDACTION_EXTENSION_TYPE,
		key: 'redaction',
		description: 'Inserts redacted block.',
		icons: {
			// eslint-disable-next-line import/dynamic-import-chunkname
			'48': () => import('@atlaskit/icon-lab/core/browser-extension'),
		},
		modules: {
			nodes: {
				default: {
					type: 'inlineExtension',
					render: async () => (args) => {
						const node = args.node as ExtensionParams<RedactionExtensionParams>;
						return (
							<TourableRedactionExtensionLoader
								contentId={contentId}
								extensionNode={node}
								isCommentContext={isCommentContext}
							/>
						);
					},
				},
			},
		},
	} as ExtensionManifest;
};
